import { Icon } from "@cadmakers-ui/icons";
import React from "react";
import Dropzone from "react-dropzone";
import ReactTextareaAutocomplete from "@webscopeio/react-textarea-autocomplete";
import { fileService } from "../../../Services";
import { UserAutocompleteItemDto, UserAutocompleteItem } from "./PingUserAutocompleteItem";
import { makeCommentPingAutocompleteProvider } from "../../../Helpers/CommentPingAutocompleteProvider";
import { Image } from "../../../Models/Image";
import ImageDropzone from "../ImageDropzone/ImageDropzone";
import "../../../Styles/CommentBox.scss";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";

type Props = {
  value: string;
  images: Image[];
  shouldAutocompleteForOtherCompanyUsers: boolean;
  onValueClear: () => void;
  onValueChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onImagesAdded: (images: Image[]) => void;
  onImageDelete: (image: Image) => void;
};

export class CommentInput extends React.Component<Props> {
  onPaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.stopPropagation();

    this.props.onImagesAdded(fileService.fileListToImages(event.clipboardData.files));
  };

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.files) {
      this.props.onImagesAdded(fileService.fileListToImages(event.currentTarget.files));
    }
  };

  onDrop = (files: File[]) => {
    this.props.onImagesAdded(fileService.filestoImages(files));
  };

  render() {
    const props = {
      onChange: this.props.onValueChange,
      onPaste: this.onPaste,
      placeholder: "Type or paste images here",
      required: true
    };

    return (
      <Dropzone onDrop={this.onDrop} noClick noKeyboard>
        {({ getRootProps }) => (
          <>
            <div {...getRootProps()} className="field">
              <span className="input-clear">
                <a onClick={this.props.onValueClear} title="Clear Comment">
                  <Icon
                    appName="GeneralLayout"
                    assetName="GENERAL_L_RemoveX"
                    className={iconStyles.smallIcon}
                  />
                </a>
              </span>

              <ReactTextareaAutocomplete
                className="commentPingAutocompleteTextArea"
                value={this.props.value}
                {...props}
                loadingComponent={() => <span>Loading</span>}
                minChar={3}
                trigger={{
                  "@": {
                    dataProvider: makeCommentPingAutocompleteProvider(
                      this.props.shouldAutocompleteForOtherCompanyUsers
                    ),
                    component: UserAutocompleteItem,
                    output: (item, trigger) => {
                      const castItem = item as UserAutocompleteItemDto;
                      return `@${castItem.code}`;
                    }
                  }
                }}
              />
              {this.props.images.length > 0 ? (
                <ImageDropzone
                  images={this.props.images}
                  onImagesAdded={this.props.onImagesAdded}
                  onImageDelete={this.props.onImageDelete}
                />
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </Dropzone>
    );
  }
}
